





























// 3rd partn libs
import {
    mapActions,
    mapGetters,
} from 'vuex';

// Components
import leaderboardCard from './leaderboard-card.vue';

// Types
import {
    RewardsRemoteConfigKeys,
} from '@shared/modules/rewards/types/constants';
import {
    ServerConfigurationProps,
} from '@shared/types/config';

export default {
    name: 'partner-leaderboard-card',
    components: {
        leaderboardCard,
    },
    props: {
        partnerId: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        ...mapGetters('leaderboards', [
            'sortLeaderboardBasedOnStatus',
            'sortOtherLeaderboardBasedOnStatus',
        ]),

        ...mapGetters('partners', ['partnerById']),

        ...mapGetters([
            'userDetails',
            'userAvatar',
        ]),

        ...mapGetters('remoteConfig', ['remoteConfigByKey']),

        ...mapGetters('serverConfig', ['serverConfigByKey']),

        isFreemiumLeaderboardsEnabled() {
            return this.serverConfigByKey(ServerConfigurationProps.isFreemiumLeaderboardsEnabled);
        },

        leaderboardData() {
            return this.sortLeaderboardBasedOnStatus.length > 0 ? this.sortLeaderboardBasedOnStatus[0] : this.sortOtherLeaderboardBasedOnStatus[0];
        },

        isLeaderboardsEnabled() {
            return Boolean(this.remoteConfigByKey(RewardsRemoteConfigKeys.IsWebLeaderboardsEnabled) && this.leaderboardData);
        },

        participantRankings() {
            return this.leaderboardData.rankings && this.leaderboardData.rankings.slice(0, 5);
        },

        partner() {
            return this.partnerById(this.partnerId);
        },
    },
    async beforeMount() {
        this.clearLeaderboardStates();

        if (this.partner.shortName !== 'SSU') {
            this.loading = true;

            await this.loadLeaderboards(1, [this.partnerId]);

            // If we didn't find a leaderboard in the ones user is participating in, then check in the other leaderboards.
            if (this.sortLeaderboardBasedOnStatus.length <= 0) {
                await this.loadLeaderboards(1, [this.partnerId], 'false');
            }

            this.loading = false;
        }
    },
    methods: {
        ...mapActions('leaderboards', {
            fetchLeaderboards: 'fetchLeaderboards',
            clearLeaderboardStates: 'clearLeaderboardStates',
        }),

        async loadLeaderboards(page = 1, partnerIds = [], participating = 'true') {
            await this.fetchLeaderboards({
                page,
                participating,
                partnerIds,
                types: ['partner'],
                statuses: ['open', 'published', 'closing', 'closed'],
            });
        },

        userRank(leaderboard) {
            if (leaderboard?.ranking?.currentRank > 5) {
                return {
                    rank: leaderboard.ranking.currentRank,
                    oldRank: leaderboard.ranking.oldRank,
                    username: this.userDetails.username,
                    country: this.userDetails.vatCountry,
                    xp: leaderboard.ranking.currentXp,
                    avatar: this.userAvatar,
                    chilizUserId: this.userDetails.externalUserId,
                };
            }
        },
        goToExtendedView(leaderboardId) {
            this.$router.push({
                path: '/rewards/leaderboard/' + leaderboardId,
            });
        },
    },
};
